export default __webpack_public_path__ + "static/media/ResumeFinal.34b4590a.pdf";